import reactComponentLoader from 'scripts/react-component-loader'

import {
  StockInfo,
  Description,
  StockAssistedSale,
  NavbarProductDetails,
  PriceTag,
  Carousel,
  WishlistButton,
  BuyBox,
  CallCenterContentDesktop,
  CallCenterContentResponsive,
  CallCenterContentMobile,
  ExclusiveSaleSiteMessage,
  AugmentedRealityFullButton,
  AugmentedRealityMiniButton
} from './'

reactComponentLoader(StockInfo, '[data-stock-info-wrapper]')
reactComponentLoader(StockAssistedSale, '[data-stock-assisted-sale-wrapper]')
reactComponentLoader(Carousel, '[data-product-images-carousel]')
reactComponentLoader(NavbarProductDetails, '[data-navbar-product-details-container]')
reactComponentLoader(Description, '[data-product-description]')
reactComponentLoader(PriceTag, '[data-product-price-tag]')
reactComponentLoader(BuyBox, '[data-product-buybox]')
reactComponentLoader(WishlistButton, '[data-product-wishlist]')
reactComponentLoader(CallCenterContentDesktop, '[data-call-center-content-desktop]')
reactComponentLoader(CallCenterContentResponsive, '[data-call-center-content-responsive]')
reactComponentLoader(CallCenterContentMobile, '[data-call-center-content-mobile]')
reactComponentLoader(ExclusiveSaleSiteMessage, '[data-exclusive-sale-site-message]')
reactComponentLoader(AugmentedRealityMiniButton, '[data-augmented-reality-mini-button-wrapper]')
reactComponentLoader(AugmentedRealityFullButton, '[data-augmented-reality-full-button-wrapper]')
